import { render, staticRenderFns } from "./case.vue?vue&type=template&id=1ff95238&scoped=true&"
import script from "./case.vue?vue&type=script&lang=ts&"
export * from "./case.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff95238",
  null
  
)

export default component.exports